import React, { useContext, useEffect, useRef, useState } from 'react';

// Components
import BaseContentContainer from '../../components/base-content-container/base-content-container';
import ChatView from '../../components/chat/chat-view';
import FeatureTitle from '../../components/feature-title/feature-title';

// Models
import { BaseContentContainerFormat } from '../../models/base-content-container';
import ChatService from '../../services/chat-service';
import { useParams } from 'react-router-dom';
import ErrorComponent from '../../components/error/error';
import { GeneralContext } from '../../providers/general-provider';
import StorageService from '../../services/storage-service';
import usePolling from '../../hooks/use-polling';

const chatService = new ChatService();
const storageService = new StorageService();
const defaultInterval = 5000;

const isNullOrUndefined = (value) => {
  return value === null || value === undefined;
}


const ChatDetail = () => {
  const { chatId } = useParams<{ chatId: string }>();
  const [messages, setMessages] = useState([]);
  const [lastMessageId, setLastMessageId] = useState(null);
  const [title, setTitle] = useState<string>();
  const [error, setError] = useState(false);
  const { setToastContent } = useContext(GeneralContext);
  const currentUser = storageService.getEmployee();

  const sendMessage = (message) => {
    if (!message) {
      return;
    }

    chatService.sendChatMessage(chatId, message).then(newMessage => {
      setMessages(messages => [...messages, newMessage]);
    }).catch(() => setToastContent({
      isOpen: true,
      text: 'Houve um erro ao enviar a mensagem.',
      type: 'error',
    }));
  }

  const checkLastMessageId = (messages: ChatMessage[]) => {
    const messagesLength = messages ? messages.length : 0;
    if (messagesLength === 0) {
      return;
    }

    for (var i = messagesLength - 1; i >= 0; i--) {
      const message = messages[i];
      if (!isNullOrUndefined(message.responsibleId)) {
        setLastMessageId(message.messageId);
        break;
      }
    }
  }


  useEffect(() => {
    if (!chatId) {
      return;
    }

    chatService.getChatDetail(chatId)
      .then(chatDetail => {
        setTitle(chatDetail.summary.responsibleName);
        setMessages(chatDetail.messages);
        checkLastMessageId(chatDetail.messages);
      }).catch(() => setError(true));
  }, [chatId]);

  // Backoff retries a failing poll many times, and a toast for each would pile up.
  const pollFailed = useRef(false);

  usePolling(() => {
    if (!chatId) {
      return Promise.resolve();
    }

    return chatService.receiveUnreadMessages(chatId, lastMessageId)
      .then(newMessages => {
        pollFailed.current = false;
        if (newMessages && newMessages.length > 0) {
          setMessages(messages => [...messages, ...newMessages]);
          checkLastMessageId(newMessages);
        }
      }).catch(error => {
        if (!pollFailed.current) {
          setToastContent({
            isOpen: true,
            text: 'Houve um erro ao buscar novas mensagens.',
            type: 'error',
          });
        }
        pollFailed.current = true;
        throw error;
      });
  }, defaultInterval, { immediate: false });

  if (error) return <ErrorComponent type='contentFull' />;

  return (
    <BaseContentContainer
      format={BaseContentContainerFormat.singleWithoutActionButtons}
      withoutShadowBox={true}
    >
      <FeatureTitle title={title} />
      <ChatView messages={messages} sendMessage={sendMessage} currentUserEmployeeId={currentUser?.id} />
    </BaseContentContainer>
  );
};

export default ChatDetail;
